
import auth_ee from "./manager"
import "./track"
import CallbackQueue from "./callback_queue"
import RemoteState from "./remote_state"
import "./flash_message"

// Wonder: is it better to do event init apart?
auth_ee.on("sign_in:success:action", () => {
  CallbackQueue.drain()
  RemoteState.refreshAndUpdateComponentPromise().done()
})
auth_ee.on("sign_up:success:action", () => {
  CallbackQueue.drain()
  RemoteState.refreshAndUpdateComponentPromise().done()
})


